import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-K49VZLEVXY';

export const initGA = () => {
  if (process.env.NODE_ENV === 'production') { // Only initialize in production
    if (GA_MEASUREMENT_ID) {
      ReactGA.initialize(GA_MEASUREMENT_ID);
      console.log('Google Analytics initialized with ID:', GA_MEASUREMENT_ID);
    } else {
      console.warn('Google Analytics Measurement ID is not set.');
    }
  } else {
    console.log('Google Analytics not initialized in development mode.');
  }
};

export const trackPageView = (path) => {
  if (process.env.NODE_ENV === 'production' && ReactGA.isInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

export const trackEvent = (category, action, label, value) => {
  if (process.env.NODE_ENV === 'production' && ReactGA.isInitialized) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
    });
  }
};
